import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useOnRouteChangeComplete = (handleRouteChangeComplete: () => void) => {
  const router = useRouter();

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChangeComplete);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);
};
